import Fab from '@mui/material/Fab';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { Button } from '@core/design-system/button';
import { styled } from '@mui/material/styles';

import themeColors from '@mais-retorno-front/theme/theme-variables';

const CircularButton = styled(Fab)`
  background-color: ${(props) =>
    props?.style?.backgroundColor ? props?.style?.backgroundColor : '#c4c4c4'};
  margin: 0 10px;
  box-shadow: none;
  box-shadow: ${(props) =>
    props?.style?.boxShadow ? props?.style?.boxShadow : null};
  min-width: 40px;
  z-index: 999;
`;

CircularButton.defaultProps = { size: 'small' };

const AppStyledTabs = styled(Tabs)`
  display: flex;
  align-items: center;
  justify-content: center;
  & .MuiButtonBase-root {
    font-weight: 700;
  }
`;

AppStyledTabs.defaultProps = {
  variant: 'fullWidth',
  scrollButtons: true,
  indicatorColor: 'secondary',
  textColor: 'primary',
};

export const AppStyledTab = styled(Tab)({
  minHeight: 40,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 500,
  textTransform: 'none',
});

export const CtaLinkButton = styled(Button)({
  contained: {
    backgroundColor: themeColors.colors.ctaColor,
    color: themeColors.colors.white,
    '&:hover': {
      backgroundColor: themeColors.colors.ctaHover,
    },
  },
});

export const ImageContainer = styled('figure')`
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
  padding: 0;
  margin-bottom: ${(props) => props.theme.spacing(4)};

  img {
    border-radius: 4px;
  }
`;

export const IframeContainer = styled('div')`
  margin-bottom: ${(props) => props.theme.spacing(4)};
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
`;

export const Iframe = styled('iframe')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

interface IStickyContainer {
  top: number;
}

export const StickyContainer = styled('div')<IStickyContainer>`
  top: ${(props) => props.top}px;
  position: sticky;
`;

export { AppStyledTabs, CircularButton };
